import React from "react";
import Page from "components/Page";
import { Props } from "./ProgrammeCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ProgrammeCustomTypes = lazyWithRetry(() =>
  import("./ProgrammeCustomTypes")
);

export default (props: Props) => (
  <Page>
    <ProgrammeCustomTypes {...props} />
  </Page>
);
